var exports = {
  "k": "VoiceParticipantsList.module__container___TklpV1",
};

module.exports = exports;
